import type {
  SonarV3CreateSessionPayloadResponse,
  SonarV3PayloadResponseError,
  SonarV3PollPayloadResponse,
} from '@web-platform/shared-universal-types/src/network/types';

export const isSonarV3ErrorPayload = (
  response: SonarV3PollPayloadResponse | SonarV3CreateSessionPayloadResponse,
): response is SonarV3PayloadResponseError => !!response.error;
